var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBonus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 195,
    viewBox: "0 0 209 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15159_185222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.862 172.243C144.738 172.243 177.063 140.073 177.063 100.389C177.063 60.7053 144.738 28.5352 104.862 28.5352C64.9859 28.5352 32.6602 60.7053 32.6602 100.389C32.6602 140.073 64.9859 172.243 104.862 172.243Z",
    fill: "url(#paint0_linear_15159_185222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.862 172.243C144.738 172.243 177.063 140.073 177.063 100.389C177.063 60.7053 144.738 28.5352 104.862 28.5352C64.9859 28.5352 32.6602 60.7053 32.6602 100.389C32.6602 140.073 64.9859 172.243 104.862 172.243Z",
    fill: "#E4E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.403646,
    d: "M60.9187 184.172C67.3449 184.172 72.5543 178.96 72.5543 172.532C72.5543 166.104 67.3449 160.893 60.9187 160.893C54.4926 160.893 49.2832 166.104 49.2832 172.532C49.2832 178.96 54.4926 184.172 60.9187 184.172Z",
    fill: "url(#paint1_linear_15159_185222)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15159_185222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.8296 24.5449H140.078C146.286 24.5449 151.318 29.5789 151.318 35.7885V156.079C151.318 162.289 146.286 167.323 140.078 167.323H69.8296C63.6221 167.323 58.5898 162.289 58.5898 156.079V35.7885C58.5898 29.5789 63.6221 24.5449 69.8296 24.5449Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.8296 24.5449H140.078C146.286 24.5449 151.318 29.5789 151.318 35.7885V156.079C151.318 162.289 146.286 167.323 140.078 167.323H69.8296C63.6221 167.323 58.5898 162.289 58.5898 156.079V35.7885C58.5898 29.5789 63.6221 24.5449 69.8296 24.5449Z",
    fill: "url(#paint2_linear_15159_185222)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.268 31.102C141.407 31.102 144.761 34.4579 144.761 38.5977V153.267C144.761 157.406 141.407 160.762 137.268 160.762H72.6397C68.5013 160.762 65.1465 157.406 65.1465 153.267V38.5977C65.1465 34.4579 68.5013 31.102 72.6397 31.102L84.5858 31.1016C84.5719 31.256 84.5648 31.4124 84.5648 31.5705C84.5648 34.4166 86.8712 36.7238 89.7163 36.7238H121.163C124.008 36.7238 126.314 34.4166 126.314 31.5705C126.314 31.4124 126.307 31.256 126.293 31.1016L137.268 31.102Z",
    fill: "url(#paint3_linear_15159_185222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.169 150.385H71.7034C70.6688 150.385 69.8301 151.224 69.8301 152.259C69.8301 153.294 70.6688 154.133 71.7034 154.133H138.169C139.203 154.133 140.042 153.294 140.042 152.259C140.042 151.224 139.203 150.385 138.169 150.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.659 134.289H71.1936C70.159 134.289 69.3203 135.128 69.3203 136.163C69.3203 137.198 70.159 138.037 71.1936 138.037H137.659C138.694 138.037 139.532 137.198 139.532 136.163C139.532 135.128 138.694 134.289 137.659 134.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.899 142.336H71.4338C70.3992 142.336 69.5605 143.175 69.5605 144.21C69.5605 145.245 70.3992 146.084 71.4338 146.084H137.899C138.934 146.084 139.773 145.245 139.773 144.21C139.773 143.175 138.934 142.336 137.899 142.336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.511788,
    filter: "url(#filter1_f_15159_185222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.689 188.138C157.889 188.138 166.968 179.056 166.968 167.852C166.968 156.649 157.889 147.566 146.689 147.566C135.489 147.566 126.41 156.649 126.41 167.852C126.41 179.056 135.489 188.138 146.689 188.138Z",
    fill: "url(#paint4_linear_15159_185222)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.511788,
    d: "M141.04 48.4887C149.302 48.4887 156 41.7887 156 33.5237C156 25.2587 149.302 18.5586 141.04 18.5586C132.778 18.5586 126.08 25.2587 126.08 33.5237C126.08 41.7887 132.778 48.4887 141.04 48.4887Z",
    fill: "url(#paint5_linear_15159_185222)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.511788,
    d: "M42.4397 38.0888C47.8408 38.0888 52.2193 33.7168 52.2193 28.3237C52.2193 22.9306 47.8408 18.5586 42.4397 18.5586C37.0386 18.5586 32.6602 22.9306 32.6602 28.3237C32.6602 33.7168 37.0386 38.0888 42.4397 38.0888Z",
    fill: "url(#paint6_linear_15159_185222)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.051 68.3125H108.391C109.346 68.3125 110.12 69.0867 110.12 70.0418C110.12 70.9969 109.346 71.7711 108.391 71.7711H71.051C70.0962 71.7711 69.3223 70.9969 69.3223 70.0418C69.3223 69.0867 70.0962 68.3125 71.051 68.3125Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.051 76.3535H108.391C109.346 76.3535 110.12 77.1277 110.12 78.0828C110.12 79.0379 109.346 79.8121 108.391 79.8121H71.051C70.0962 79.8121 69.3223 79.0379 69.3223 78.0828C69.3223 77.1277 70.0962 76.3535 71.051 76.3535Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_15159_185222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.833 51H49.1667C46.3132 51 44 53.3132 44 56.1667V82.0002C44 84.8537 46.3132 87.1669 49.1667 87.1669H160.833C163.687 87.1669 166 84.8537 166 82.0002V56.1667C166 53.3132 163.687 51 160.833 51Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.833 51H49.1667C46.3132 51 44 53.3132 44 56.1667V82.0002C44 84.8537 46.3132 87.1669 49.1667 87.1669H160.833C163.687 87.1669 166 84.8537 166 82.0002V56.1667C166 53.3132 163.687 51 160.833 51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3639 76.4375H78.4518V69.0429H79.3486L83.2073 74.8233H83.2893V69.0429H84.2014V76.4375H83.3046L79.4459 70.6776H79.3639V76.4375ZM86.8456 72.5019C86.3366 72.5019 85.9113 72.3397 85.5696 72.0151C85.2314 71.6871 85.0623 71.255 85.0623 70.7186C85.0623 70.1823 85.2314 69.7518 85.5696 69.4273C85.9113 69.1027 86.3366 68.9404 86.8456 68.9404C87.3683 68.9404 87.8039 69.1027 88.1524 69.4273C88.5008 69.7518 88.6751 70.1823 88.6751 70.7186C88.6751 71.255 88.5008 71.6871 88.1524 72.0151C87.8039 72.3397 87.3683 72.5019 86.8456 72.5019ZM86.8456 71.846C87.1497 71.846 87.394 71.7435 87.5784 71.5385C87.7629 71.3336 87.8552 71.0603 87.8552 70.7186C87.8552 70.3736 87.7646 70.1003 87.5836 69.8987C87.4025 69.6971 87.1565 69.5964 86.8456 69.5964C86.5552 69.5964 86.3212 69.6971 86.1436 69.8987C85.9694 70.1003 85.8822 70.3736 85.8822 70.7186C85.8822 71.0603 85.9694 71.3336 86.1436 71.5385C86.3212 71.7435 86.5552 71.846 86.8456 71.846ZM88.547 73.9214H85.2161V73.0861H88.547V73.9214ZM91.596 76.4375V70.0217H91.5755L89.618 71.4309V70.4573L91.5857 69.0429H92.4876V76.4375H91.596ZM96.249 76.4375V70.0217H96.2285L94.271 71.4309V70.4573L96.2387 69.0429H97.1406V76.4375H96.249ZM100.902 76.4375V70.0217H100.881L98.9239 71.4309V70.4573L100.892 69.0429H101.794V76.4375H100.902ZM105.555 76.4375V70.0217H105.534L103.577 71.4309V70.4573L105.545 69.0429H106.447V76.4375H105.555ZM108.276 71.1747C108.276 70.529 108.508 69.9927 108.973 69.5656C109.438 69.1352 110.018 68.9199 110.715 68.9199C111.375 68.9199 111.933 69.1164 112.391 69.5093C112.849 69.9021 113.078 70.3821 113.078 70.9492C113.078 71.3592 112.965 71.7538 112.739 72.133C112.514 72.5122 112.09 73.0229 111.469 73.6652L109.598 75.5971V75.6176H113.201V76.4375H108.322V75.8021L110.925 73.0605C111.421 72.5378 111.749 72.1415 111.909 71.8716C112.073 71.6017 112.155 71.3131 112.155 71.0056C112.155 70.6503 112.012 70.348 111.725 70.0986C111.441 69.8492 111.096 69.7245 110.69 69.7245C110.256 69.7245 109.894 69.8628 109.603 70.1396C109.313 70.4163 109.168 70.7613 109.168 71.1747V71.1798H108.276V71.1747ZM114.22 71.1747C114.22 70.529 114.453 69.9927 114.917 69.5656C115.382 69.1352 115.963 68.9199 116.66 68.9199C117.319 68.9199 117.878 69.1164 118.335 69.5093C118.793 69.9021 119.022 70.3821 119.022 70.9492C119.022 71.3592 118.909 71.7538 118.684 72.133C118.458 72.5122 118.035 73.0229 117.413 73.6652L115.543 75.5971V75.6176H119.145V76.4375H114.267V75.8021L116.87 73.0605C117.365 72.5378 117.693 72.1415 117.854 71.8716C118.018 71.6017 118.1 71.3131 118.1 71.0056C118.1 70.6503 117.956 70.348 117.669 70.0986C117.386 69.8492 117.041 69.7245 116.634 69.7245C116.2 69.7245 115.838 69.8628 115.548 70.1396C115.257 70.4163 115.112 70.7613 115.112 71.1747V71.1798H114.22V71.1747Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7489,
    y: 59.5106,
    width: 19.5772,
    height: 19.5772,
    rx: 9.78859,
    stroke: "#D9D9D9",
    strokeWidth: 0.247813
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.6253,
    cy: 69.387,
    r: 7.93,
    fill: "url(#paint7_linear_15159_185222)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_15159_185222)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6241 65.7832C62.4204 65.7832 63.0659 66.4287 63.0659 67.225H64.5017C64.9032 67.225 65.2286 67.5505 65.2286 67.9519V71.5445C65.2286 71.9459 64.9032 72.2714 64.5017 72.2714H58.7464C58.345 72.2714 58.0195 71.9459 58.0195 71.5445V67.9519C58.0195 67.5505 58.345 67.225 58.7464 67.225H60.1823C60.1823 66.4287 60.8278 65.7832 61.6241 65.7832ZM64.4185 68.1815L63.0322 69.2139C62.1971 69.8358 61.0516 69.8319 60.2207 69.2043L58.8675 68.1822C58.7881 68.1222 58.6751 68.138 58.6151 68.2174C58.5551 68.2968 58.5708 68.4098 58.6503 68.4698L60.0034 69.4919C60.9622 70.2161 62.2839 70.2206 63.2475 69.5029L64.6338 68.4706C64.7136 68.4111 64.7302 68.2982 64.6707 68.2184C64.6113 68.1385 64.4983 68.122 64.4185 68.1815ZM61.6241 66.1437C61.0269 66.1437 60.5427 66.6278 60.5427 67.225H62.7054C62.7054 66.6278 62.2213 66.1437 61.6241 66.1437Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5333 60.1504H122.355C123.45 60.1504 124.338 61.038 124.338 62.1329C124.338 63.2278 123.45 64.1154 122.355 64.1154H79.5333C78.4384 64.1154 77.5508 63.2278 77.5508 62.1329C77.5508 61.038 78.4384 60.1504 79.5333 60.1504Z",
    fill: "#E1E9F6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_15159_185222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.833 92H49.1667C46.3132 92 44 94.3132 44 97.1667V123C44 125.854 46.3132 128.167 49.1667 128.167H160.833C163.687 128.167 166 125.854 166 123V97.1667C166 94.3132 163.687 92 160.833 92Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.833 92H49.1667C46.3132 92 44 94.3132 44 97.1667V123C44 125.854 46.3132 128.167 49.1667 128.167H160.833C163.687 128.167 166 125.854 166 123V97.1667C166 94.3132 163.687 92 160.833 92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3639 117.438H78.4518V110.043H79.3486L83.2073 115.823H83.2893V110.043H84.2014V117.438H83.3046L79.4459 111.678H79.3639V117.438ZM86.8456 113.502C86.3366 113.502 85.9113 113.34 85.5696 113.015C85.2314 112.687 85.0623 112.255 85.0623 111.719C85.0623 111.182 85.2314 110.752 85.5696 110.427C85.9113 110.103 86.3366 109.94 86.8456 109.94C87.3683 109.94 87.8039 110.103 88.1524 110.427C88.5008 110.752 88.6751 111.182 88.6751 111.719C88.6751 112.255 88.5008 112.687 88.1524 113.015C87.8039 113.34 87.3683 113.502 86.8456 113.502ZM86.8456 112.846C87.1497 112.846 87.394 112.744 87.5784 112.539C87.7629 112.334 87.8552 112.06 87.8552 111.719C87.8552 111.374 87.7646 111.1 87.5836 110.899C87.4025 110.697 87.1565 110.596 86.8456 110.596C86.5552 110.596 86.3212 110.697 86.1436 110.899C85.9694 111.1 85.8822 111.374 85.8822 111.719C85.8822 112.06 85.9694 112.334 86.1436 112.539C86.3212 112.744 86.5552 112.846 86.8456 112.846ZM88.547 114.921H85.2161V114.086H88.547V114.921ZM91.596 117.438V111.022H91.5755L89.618 112.431V111.457L91.5857 110.043H92.4876V117.438H91.596ZM96.249 117.438V111.022H96.2285L94.271 112.431V111.457L96.2387 110.043H97.1406V117.438H96.249ZM100.902 117.438V111.022H100.881L98.9239 112.431V111.457L100.892 110.043H101.794V117.438H100.902ZM105.555 117.438V111.022H105.534L103.577 112.431V111.457L105.545 110.043H106.447V117.438H105.555ZM108.276 112.175C108.276 111.529 108.508 110.993 108.973 110.566C109.438 110.135 110.018 109.92 110.715 109.92C111.375 109.92 111.933 110.116 112.391 110.509C112.849 110.902 113.078 111.382 113.078 111.949C113.078 112.359 112.965 112.754 112.739 113.133C112.514 113.512 112.09 114.023 111.469 114.665L109.598 116.597V116.618H113.201V117.438H108.322V116.802L110.925 114.06C111.421 113.538 111.749 113.142 111.909 112.872C112.073 112.602 112.155 112.313 112.155 112.006C112.155 111.65 112.012 111.348 111.725 111.099C111.441 110.849 111.096 110.724 110.69 110.724C110.256 110.724 109.894 110.863 109.603 111.14C109.313 111.416 109.168 111.761 109.168 112.175V112.18H108.276V112.175ZM115.773 114.025V113.246H116.66C117.083 113.246 117.43 113.124 117.7 112.882C117.97 112.636 118.105 112.325 118.105 111.949C118.105 111.573 117.98 111.275 117.731 111.052C117.481 110.83 117.128 110.719 116.67 110.719C116.246 110.719 115.901 110.832 115.635 111.058C115.368 111.283 115.215 111.591 115.174 111.98H114.287C114.338 111.351 114.581 110.851 115.015 110.479C115.452 110.106 116.017 109.92 116.711 109.92C117.377 109.92 117.931 110.099 118.371 110.458C118.812 110.817 119.032 111.273 119.032 111.826C119.032 112.287 118.896 112.675 118.622 112.989C118.349 113.304 117.98 113.502 117.515 113.584V113.604C118.076 113.639 118.522 113.818 118.853 114.142C119.184 114.464 119.35 114.884 119.35 115.403C119.35 115.816 119.234 116.189 119.002 116.52C118.769 116.852 118.455 117.108 118.059 117.289C117.662 117.47 117.223 117.56 116.742 117.56C115.976 117.56 115.36 117.369 114.892 116.987C114.424 116.604 114.173 116.102 114.138 115.48H115.025C115.066 115.866 115.238 116.177 115.543 116.413C115.847 116.645 116.243 116.761 116.731 116.761C117.22 116.761 117.621 116.636 117.936 116.387C118.253 116.138 118.412 115.82 118.412 115.434C118.412 115 118.258 114.657 117.951 114.404C117.647 114.151 117.23 114.025 116.701 114.025H115.773Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7489,
    y: 100.511,
    width: 19.5772,
    height: 19.5772,
    rx: 9.78859,
    stroke: "#D9D9D9",
    strokeWidth: 0.247813
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.6253,
    cy: 110.387,
    r: 7.93,
    fill: "url(#paint8_linear_15159_185222)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_15159_185222)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6241 106.783C62.4204 106.783 63.0659 107.429 63.0659 108.225H64.5017C64.9032 108.225 65.2286 108.55 65.2286 108.952V112.544C65.2286 112.946 64.9032 113.271 64.5017 113.271H58.7464C58.345 113.271 58.0195 112.946 58.0195 112.544V108.952C58.0195 108.55 58.345 108.225 58.7464 108.225H60.1823C60.1823 107.429 60.8278 106.783 61.6241 106.783ZM64.4185 109.181L63.0322 110.214C62.1971 110.836 61.0516 110.832 60.2207 110.204L58.8675 109.182C58.7881 109.122 58.6751 109.138 58.6151 109.217C58.5551 109.297 58.5708 109.41 58.6503 109.47L60.0034 110.492C60.9622 111.216 62.2839 111.221 63.2475 110.503L64.6338 109.471C64.7136 109.411 64.7302 109.298 64.6707 109.218C64.6113 109.139 64.4983 109.122 64.4185 109.181ZM61.6241 107.144C61.0269 107.144 60.5427 107.628 60.5427 108.225H62.7054C62.7054 107.628 62.2213 107.144 61.6241 107.144Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5333 101.15H122.355C123.45 101.15 124.338 102.038 124.338 103.133C124.338 104.228 123.45 105.115 122.355 105.115H79.5333C78.4384 105.115 77.5508 104.228 77.5508 103.133C77.5508 102.038 78.4384 101.15 79.5333 101.15Z",
    fill: "#E1E9F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15159_185222",
    x: 31.4593,
    y: -3.24736,
    width: 146.99,
    height: 197.038,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.661721
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5653
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.427451 0 0 0 0 0.537255 0 0 0 0.190587 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15159_185222"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15159_185222",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_15159_185222",
    x: 123.763,
    y: 144.92,
    width: 45.8524,
    height: 45.866,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.32344,
    result: "effect1_foregroundBlur_15159_185222"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_15159_185222",
    x: 31.0375,
    y: 40.325,
    width: 147.925,
    height: 62.091,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.2875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.48125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.427451 0 0 0 0 0.537255 0 0 0 0.217466 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15159_185222"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15159_185222",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_15159_185222",
    x: 31.0375,
    y: 81.325,
    width: 147.925,
    height: 62.091,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.2875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.48125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.427451 0 0 0 0 0.537255 0 0 0 0.217466 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15159_185222"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15159_185222",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15159_185222",
    x1: 104.862,
    y1: 28.5352,
    x2: 104.862,
    y2: 172.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFF7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6EAEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15159_185222",
    x1: 48.8686,
    y1: 189.872,
    x2: 65.2081,
    y2: 158.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15159_185222",
    x1: 121.746,
    y1: 45.4613,
    x2: 55.5768,
    y2: 140.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15159_185222",
    x1: 136.641,
    y1: 17.0504,
    x2: -137.454,
    y2: 326.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4251DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15159_185222",
    x1: 125.687,
    y1: 198.074,
    x2: 154.165,
    y2: 143.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15159_185222",
    x1: 125.547,
    y1: 55.8183,
    x2: 146.555,
    y2: 15.7605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_15159_185222",
    x1: 32.3116,
    y1: 42.8715,
    x2: 46.0057,
    y2: 16.7122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_15159_185222",
    x1: 53.4127,
    y1: 81.201,
    x2: 64.5427,
    y2: 59.9712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_15159_185222",
    x1: 54.603,
    y1: 103.706,
    x2: 54.603,
    y2: 117.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9061B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#724D90"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15159_185222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 209,
    height: 195,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_15159_185222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.20909,
    height: 6.48818,
    fill: "white",
    transform: "translate(58.0195 65.7832)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_15159_185222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.20909,
    height: 6.48818,
    fill: "white",
    transform: "translate(58.0195 106.783)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonus);
export default __webpack_public_path__ + "static/media/bonus.b37070e9189647df7e832e753f910079.svg";
export { ForwardRef as ReactComponent };